// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

// Local Imports
import endPoints from '../../constant';
import axiosInstance from '../../http';

export interface InitialStateProps {
  allSalons?: any;
  loading?: boolean;
  error?: string | null;
}

const initialState: InitialStateProps = {
  allSalons: [],
  loading: false,
  error: null,
};

// All Salons API Calling
export const allSalonsAPI = createAsyncThunk(
  'dashboard/salons',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(endPoints.allSalonsListing);
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(
          error?.message + '. Please check your Internet Connection!'
        );
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Salons Slice
export const salonSlice = createSlice({
  name: 'dashboard/salons',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(allSalonsAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(allSalonsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.allSalons = action.payload;
        state.error = null;
      })
      .addCase(allSalonsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(PURGE, (state) => {
        state.allSalons = [];
      });
  },
});

// Action creators are generated for each case reducer function
// export const {  } = salonSlice.actions;

export default salonSlice.reducer;
